export default __webpack_public_path__ + "static/media/facilitation-tools.916b27a4.svg";